'use client';

import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from "@/lib/utils";

function Switch({ className, onFocus, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      onFocus={onFocus}
      className={cn(
        'data-[state=checked]:bg-primary focus-visible:border-ring focus-visible:ring-ring/50 shadow-xs peer inline-flex h-6 w-10 shrink-0 items-center rounded-full border border-transparent outline-none transition-all focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-input sm:h-[1.15rem] sm:w-8',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        onFocus={onFocus}
        data-slot="switch-thumb"
        className={cn(
          'bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-5 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0 sm:size-4',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
